<template>
    <div>
        <div class="hv-product-youtube-tv productVideoWrapper"> 
            <div class="video-modal productVideoBtn" v-if="propUrl.length > 0">   
                <div class="video-container">
                    <iframe id="productVideoiFrame" height="100%" width="100%" :src="propUrl + '?rel=0&enablejsapi=1'" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
                </div>
            </div>                       
        </div>
    </div>
</template> 

<script>
export default {
    name: "product-youtube-tv",
    inject: {
        itemId: {
            default: null
        }
    },
    data() {
        return {
            productVideoUrl: ""
        }
    },
    computed:
    {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`];
        },
        propUrl(){
          var valName = "";
          $.each( this.currentVariation.variationProperties, function( index, group ){
              if(group.id == 2){
                $.each( group.properties, function( index2, value2 ){
                  if(value2.id == 607){
                    valName = value2.values.value;            
                  }
                  else{
                    valName = "";
                  }
                });
            }
            else{
              valName = "";
            }
          }); 
          return valName;
        }
    }
}
</script>
